import React, { useEffect, useState } from "react";
import Grid from "./Grid/Grid";
import Toolbar from "./Toolbar/Toolbar";

const initialGrid = {
  page: 0,
  hasMore: false,
  loading: false,
  events: null,
};

const PageGrid = ({ services, redirect, routes, actions }) => {
  const [filter, setFilter] = useState({
    text: "",
    process: "",
    includeRead: true,
  });
  const [grid, setGrid] = useState(initialGrid);

  useEffect(() => {
    if (filter) {
      getEvents(0);
    }
  }, [filter]);

  const setRead = (props) => {
    actions.setRead(props.id);
    return services.fetchMarkAsRead(props);
  };

  const getEvents = (page) => {
    if (!grid.loading) {
      let nextPage = 0;
      if (page == 0) {
        setGrid(initialGrid);
      } else {
        nextPage = grid.page + 1;
        setGrid({ ...grid, loading: true, hasMore: false });
      }
      services
        .fetchGetEventAlerts({
          filter,
          offset: nextPage * 25,
          length: 25,
        })
        .then((r) => {
          const prevEvents = nextPage == 0 ? [] : grid.events || [];
          setGrid({
            loading: false,
            hasMore: r.events.length >= 25,
            page: nextPage,
            events: [...prevEvents, ...r.events],
          });
        });
    }
  };

  const changeFilter = (props) => {
    setFilter({
      ...filter,
      ...props,
    });
  };

  return (
    <div>
      <Toolbar
        onChange={changeFilter}
        filter={filter}
        counters={{ total: grid.events ? grid.events.length : 0 }}
      />
      <Grid
        grid={grid}
        getEvents={getEvents}
        redirect={redirect}
        setRead={setRead}
        routes={routes}
      />
    </div>
  );
};

export default PageGrid;
